import { useEffect, useState } from "react";
import NavBar from "@/pages/home/components/NavBar";
import Hero from "@/pages/home/components/Hero";
import Intro from "@/pages/home/components/Intro";
import Timeline from "@/pages/home/components/Timeline";
import FilmGallery from "@/pages/home/components/FilmGallery";
import Themes from "@/pages/home/components/Themes";
import People from "@/pages/home/components/People";
import ViewingGuide from "@/pages/home/components/ViewingGuide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </a>
  );
}

export default function Home() {
  return (
    <div className="w-full bg-background-50 overflow-x-hidden">
      <NavBar />
      <main>
        <Hero />
        <Intro />
        <Timeline />
        <FilmGallery />
        <Themes />
        <People />
        <ViewingGuide />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}